import { CURRENCY_CODE } from "@/lib/constant";
import { getSelectedVariants, getVariants } from "@repo/lib/helpers";

export const getProductNames = (lineItems) =>
  lineItems?.length > 0 ? lineItems?.map(({ name }) => name)?.join(",") : "";

export const getProductSKUs = (lineItems) =>
  lineItems?.length > 0 ? lineItems?.map(({ sku }) => sku)?.join(",") : "";

export const getProductImageURI = (product) => {
  if (Array.isArray(product?.images) && product.images.length > 0) {
    return product.images
      .map((img) => img?.imageURI)
      .filter(Boolean)
      .join(",");
  }
  return product?.image?.imageURI ?? "";
};

export const getProductCategoriesNames = (categories) =>
  categories?.map((cat) => cat.name).join(",") ?? "";

export const getFormattedProduct = (product, couponName) => {
  const {
    price,
    discount,
    sku,
    productOptions = [],
    isStockStatus,
    categories,
    name,
    brand = "",
    quantity = 1,
  } = product;
  return {
    quantity,
    price,
    ...(couponName && { couponName }),
    image_url: getProductImageURI(product),
    product_id: sku,
    ...(productOptions?.length > 0 && {
      product_variant:
        getSelectedVariants(productOptions) || getVariants(productOptions),
    }),
    discount,
    currency: CURRENCY_CODE,
    availability: isStockStatus,
    category: getProductCategoriesNames(categories),
    product_name: name,
    brand: brand ?? "Alhome",
  };
};

export const getFormattedProductItems = (lineItems, couponName) =>
  lineItems?.length > 0
    ? lineItems.map((item) => ({ ...getFormattedProduct(item, couponName) }))
    : [];

export const getPurchaseInfo = (orderInfo) => {
  const { amounts, lineItems, paymentMethod, transactionId, orderId } =
    orderInfo;
  const { total, tax, subTotal, shippingCharges, couponDiscount, couponName } =
    amounts;
  return {
    total,
    couponName,
    shippingCharges,
    discount: couponDiscount,
    tax,
    transaction_id: transactionId,
    order_id: orderId,
    paymentMode: paymentMethod,
    subTotal,
    product_id: getProductSKUs(lineItems),
    product_names: getProductNames(lineItems),
    currency: CURRENCY_CODE,
    items: getFormattedProductItems(lineItems, couponName),
    no_of_product: lineItems?.length,
  };
};
